// extracted by mini-css-extract-plugin
export default {"btn":"buttonBorder_btn__iTWUb"};